import { useState } from 'react';
import Select from 'react-select';
import { PALETTECOLORS } from '../../../main/constants/paletteColors';

interface Props {
    onChange: (name: string, value: number | string | undefined) => void;
    value: number | string | undefined;
    name: string;
}

export default function ColorSelector({ onChange, value, name }: Props) {
    const [colors] = useState(PALETTECOLORS);

    return (
        <div className='mb-2'>
            <label htmlFor='colors' className='form-label form-label'>
                Color *
            </label>
            <Select
                className='basic-single'
                classNamePrefix='select'
                isSearchable
                name='colors'
                options={colors}
                onChange={(selectedColor) => {
                    onChange(name, selectedColor?.value);
                }}
                value={
                    colors.find((color) => color.value === value) ?? {
                        label: `Seleccione`,
                        value: '',
                    }
                }
                formatOptionLabel={(option) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                            style={{
                                width: '20px',
                                height: '20px',
                                borderRadius: '50%',
                                backgroundColor: option.value,
                                marginRight: '10px',
                            }}
                        ></div>
                        <span>{`${option.label}`}</span>
                    </div>
                )}
            />
        </div>
    );
}
